import customerLeavesChatSound from "./files/customerLeaving.mp3";
import newMessageSound from "./files/Notification2_1.mp3";
import newChatSound from "./files/Notification3_1.mp3";

const soundAlertCustomerLeavesChat = new Audio(customerLeavesChatSound);
const soundAlertNewChat = new Audio(newChatSound);
const soundAlertNewMessage = new Audio(newMessageSound);

export { soundAlertCustomerLeavesChat, soundAlertNewChat, soundAlertNewMessage };
